export default __webpack_public_path__ + "b89826e79195acf34b26ce4ec7d6e54d.svg";